import '../styles/globals.css'
import 'react-toastify/dist/ReactToastify.css';
import { SessionProvider } from "next-auth/react";
import { io } from "socket.io-client";

const soc = io(process.env.NEXT_PUBLIC_SOCKETURL);

export default function App({
  Component,
  pageProps: { session, ...pageProps },
}) {

  return (
    <SessionProvider session={session}>
      <Component {...pageProps} />
    </SessionProvider>
  )
}

export {soc};
